import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { usePageTitle } from '../../hooks/usePageTitle';
import { usePageHeader } from '../../providers/PageHeaderProvider';
import { MessagePatientView } from '../../components/monitoring/messages/view/MessagePatientView';

export function MonitoringMessageView() {
    usePageTitle('Monitoring · Messages');
    const { setTitle, setSubtitle } = usePageHeader();
    const { patientId = '' } = useParams<{ patientId: string }>();

    useEffect(() => {
        setTitle('Messages');
        return () => {
            setTitle(null);
            setSubtitle(null);
        };
    }, [setTitle, setSubtitle]);

    // Keyed by patient: Prev/Next start fresh (tab, remembered neighbours, the thread's draft).
    return (
        <div className="flex h-full flex-col overflow-hidden bg-gray-100">
            <MessagePatientView key={patientId} patientId={patientId} />
        </div>
    );
}
